import {
  InventoryHistory,
  InventoryHistoryDetailFromAPI,
} from 'types/product/productInventoryTypes';

export function mapInventoryHistoryData(
  data?: InventoryHistoryDetailFromAPI[] | null
): InventoryHistory[] {
  if (!Array.isArray(data)) return [];

  return data.map((item, index) => ({
    id: index + 1,
    date: item.date,
    userLogin: item.user_login,
    quantity: item.quantity,
    comment: item.comment,
  }));
}
